/**
 * The signed-in paths that are an app shell, not a prerendered page. The site's `SITE_ROUTES` (kind `spa`) is checked
 * against this list when it loads, and the edge Worker serves `site/_app/index.html` for exactly these paths.
 */
export const SPA_PATHS = ["/recommended", "/collections", "/collections/manage", "/profile", "/profile/following", "/profile/settings"] as const;

export type SpaPath = (typeof SPA_PATHS)[number];
